__turbopack_context__.v({
  "content": "Wd4AAa_content",
  "icon": "Wd4AAa_icon",
  "infoGrid": "Wd4AAa_infoGrid",
  "infoGridItem": "Wd4AAa_infoGridItem",
  "infoGridRowItem": "Wd4AAa_infoGridRowItem",
  "triggerButton": "Wd4AAa_triggerButton",
  "wrapper": "Wd4AAa_wrapper",
});
